import {
  initialState,
  Actions,
  State,
  DELETE_COMMENT,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_ERROR,
  RESET_DELETE_COMMENT,
} from '../../types/comment/delete-comment';

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_COMMENT:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_COMMENT_SUCCESS:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_COMMENT_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_COMMENT:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
